import { useMemo } from 'react';
import {
    aggregateAgencyStats,
    aggregateCategoriesWithStats,
    calculateCompanyStats,
    mapRiskAgents,
    mapAgencyChartData,
} from '../utils/agencyStatsAggregation';

export const useAgencyDashboard = (
    agencyUsers: any[],
    companyDocumentCount: number,
    companyDocumentFieldCount: number,
    agentDocumentTypesCount: number,
    agentDocumentFieldsCount: number,
    companyDocuments: any[] | null,
    companyFieldValues: Record<string, any> | null,
    categories: any[]
) => {
    const now = new Date();

    const agencyStats = useMemo(
        () => aggregateAgencyStats(agencyUsers, agentDocumentTypesCount, agentDocumentFieldsCount),
        [agencyUsers, agentDocumentTypesCount, agentDocumentFieldsCount]
    );

    const categoriesWithStats = useMemo(
        () => aggregateCategoriesWithStats(categories, agencyUsers),
        [categories, agencyUsers]
    );

    const companyStats = useMemo(
        () => calculateCompanyStats(companyDocuments, companyFieldValues, companyDocumentCount, companyDocumentFieldCount, now),
        [companyDocuments, companyFieldValues, companyDocumentCount, companyDocumentFieldCount, now]
    );

    const riskAgents = useMemo(() => mapRiskAgents(agencyUsers), [agencyUsers]);

    const agencyChartData = useMemo(() => mapAgencyChartData(agencyUsers), [agencyUsers]);

    return {
        agencyStats,
        categoriesWithStats,
        companyStats,
        riskAgents,
        agencyChartData
    };
};
